import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = {
  settings: {
    bookMode: false,
    siteMode: "explore",
    fontLarge: false,
  },
};

const slice = createSlice({
  name: "settings",
  initialState,

  reducers: {
    toggleBookMode: (state, action) => {
      state.settings.bookMode = !state.settings.bookMode;
    },
    setSiteMode: (state, action) => {
      state.settings.siteMode = action.payload;
    },
    toggleFontSize: (state) => {
      state.settings.fontLarge = !state.settings.fontLarge;
    },
    resetSiteMode: (state) => {
      state.settings.siteMode = initialState.settings.siteMode;
    },
  },
});

export const { toggleBookMode, setSiteMode, resetSiteMode, toggleFontSize } =
  slice.actions;
export default slice.reducer;
